module.exports = __webpack_public_path__ + "img/logo-um-smaller.1d3c6327.png";